export enum S3FileTypeEnum {
  IMAGE = 'image',
  VIDEO = 'video',
  EMBED = 'embed',
  OTHER = 'other'
}
